import { DesktopSideBarFilters } from '@/components/atomic/atoms';
import { Text } from '@/components/atomic/nuclei';

const CollectionsListSidebar = ({ priceRange }) => (
  <div className='md:w-82 border-r border-gray me-6 md:sticky md:top-0 hidden md:block h-full'>
    <Text
      className='text-lg text-nero capitalize pb-4 block font-Montserrat font-medium'
      content='Filters'
    />
    <div className='pb-32'>
      <div
        className='border-t border-gray block border-b'
        id='price'
      >
        <DesktopSideBarFilters priceRange={priceRange} />
      </div>
    </div>
  </div>
);

export default CollectionsListSidebar;
